const Constant = {
	crud: {
		create: 'CREATE',
		update: 'UPDATE',
		delete: 'DELETE',
	},
	cloud_name: 'duxzkjxo5',
	api_url_upload_img: process.env.REACT_APP_CLOUDINARY_UPLOAD || '',
	api_url_destroy_img: process.env.REACT_APP_CLOUDINARY_DESTROY || '',
	api_key: 287483298955728,
	upload_preset_value: process.env.REACT_APP_CLOUDINARY_PRESET || '',
	categories_new: [
		{
			value: 'Công ty',
		},
		{
			value: 'PCCC',
		},
		{
			value: 'Trang phục tác chiến',
		},
		{
			value: 'Phương tiện tác chiến',
		},
		{ value: 'Defire' },
		{ value: 'Gsafe' },
		{ value: 'Defender' },
		{ value: 'Tàu BK' },
		{ value: 'Tàu điện' },
		{ value: 'Hợp tác và phát triển' },
	],
	apiUrl: process.env.REACT_APP_API_URL || 'http://76.13.212.191/api',
	apiKey: process.env.REACT_APP_API_KEY || 'al-4AuAJ-Tv5H_0b-KIzNm-SXyDkTAJDEonGeYAPd5SwKr',
};
export default Constant;
